// Module
var code = " <bringoz-button type=\"tertiary\" class=\"show-button\" (on-click)=\"$ctrl.onShowPanel($event)\"> <bringoz-icon icon-name=\"settings-outline\" class=\"gray-102\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;